export const CampaignCriterion = {
  properties: {
    CriterionType: {
      'bulk-upload-header': 'Type',
      'bulk-upload-mapper': function (value) {
        switch (value) {
          case 'Device':
            return 'Campaign DeviceOS Criterion';
          case 'Age':
            return 'Campaign Age Criterion';
          case 'Gender':
            return 'Campaign Gender Criterion';
          case 'Radius':
            return 'Campaign Radius Criterion';
          case 'Location':
            return 'Campaign Location Criterion';
          case 'NegativeLocation':
            return 'Campaign Negative Location Criterion';
          case 'LocationIntentCriterion':
            return 'Campaign Location Intent Criterion';
          case 'DayTime':
            return 'Campaign Day Time Criterion';
          case 'CompanyName':
            return 'Campaign Company Name Criterion';
          case 'NegativeCompanyName':
            return 'Campaign Negative Company Name Criterion';
          case 'Industry':
            return 'Campaign Industry Criterion';
          case 'NegativeIndustry':
            return 'Campaign Negative Industry Criterion';
          case 'JobFunction':
            return 'Campaign Job Function Criterion';
          case 'JobTitle':
            return 'Campaign Job Title Criterion';
          case 'JobSeniority':
            return 'Campaign Job Seniority Criterion';
          case 'NegativeJobFunction':
            return 'Campaign Negative Job Function Criterion';
          case 'NegativeStore':
            return 'Campaign Negative Store Criterion';
          case 'DealCriterion':
            return 'Campaign Deal Criterion';
          default:
            return 'Campaign Unknown Criterion';
        }
      },
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
  },
};
